import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { FC } from 'react';

const MessageIcon: FC<SvgIconProps> = (props) => (
  <SvgIcon width={24} height={24} viewBox="0 0 22 22" {...props}>
    <path
      opacity="0.4"
      d="M1.83301 11.8891V6.40742C1.83301 3.87742 3.88634 1.83325 6.41634 1.83325H15.583C18.113 1.83325 20.1663 3.87742 20.1663 6.40742V12.8058C20.1663 15.3266 18.113 17.3708 15.583 17.3708H14.208C13.9238 17.3708 13.6488 17.5083 13.4747 17.7374L12.0997 19.5616C11.4947 20.3683 10.5047 20.3683 9.89967 19.5616L8.52467 17.7374C8.37801 17.5358 8.04801 17.3708 7.79134 17.3708H6.41634C3.88634 17.3708 1.83301 15.3266 1.83301 12.8058V11.8891Z"
      fill="inherit"
    />
    <path
      d="M10.9997 11.0001C10.4863 11.0001 10.083 10.5876 10.083 10.0834C10.083 9.57925 10.4955 9.16675 10.9997 9.16675C11.5038 9.16675 11.9163 9.57925 11.9163 10.0834C11.9163 10.5876 11.513 11.0001 10.9997 11.0001Z"
      fill="inherit"
    />
    <path
      d="M14.6667 11.0001C14.1533 11.0001 13.75 10.5876 13.75 10.0834C13.75 9.57925 14.1625 9.16675 14.6667 9.16675C15.1708 9.16675 15.5833 9.57925 15.5833 10.0834C15.5833 10.5876 15.18 11.0001 14.6667 11.0001Z"
      fill="inherit"
    />
    <path
      d="M7.33366 11.0001C6.82033 11.0001 6.41699 10.5876 6.41699 10.0834C6.41699 9.57925 6.82949 9.16675 7.33366 9.16675C7.83783 9.16675 8.25033 9.57925 8.25033 10.0834C8.25033 10.5876 7.84699 11.0001 7.33366 11.0001Z"
      fill="inherit"
    />
  </SvgIcon>
);

export default MessageIcon;
